<template>
  <el-dialog
    visible
    :before-close="emitClose"
    title="录入其他类型房源"
    size="normal"
  >
    <start-form @mounted="setEl" />

    <div slot="footer">
      <el-button @click="emitClose">取消</el-button>
      <el-button type="primary" @click="submit" :loading="loading['start-form']"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import StartForm from './forms/start-form'
import { upload, startProcess, validateRoomAndPrice } from './fetch'
import mLoading from '@/mixins/loading'

// eslint-disable-next-line
const PROCESS_KEY = 'process-other-house-input-v1'
// eslint-disable-next-line
const processName = '录入其他类型房源'

export default {
  components: {
    StartForm,
  },

  mixins: [mLoading],

  data() {
    return {
      loading: {
        'start-form': false,
      },
    }
  },

  methods: {
    setEl(formEl, elForm) {
      this.formEl = formEl
      this.elForm = elForm
    },

    emitClose() {
      this.$emit('close')
    },

    submit() {
      this.elForm.validate(async valid => {
        if (!valid) return

        const err = this.formEl.validateFC()
        if (err instanceof Error) {
          this.$message.warning(err.message)
          return
        }

        const form = this.formEl.getForm()

        try {
          const notRepeated =
            (await validateRoomAndPrice.call(this, form)) === null
          console.log(notRepeated)
          if (!notRepeated) {
            this.$message.warning('数据重复，请重新录入')
            return
          }
        } catch (error) {
          this.$message.warning(`项目参数校验不通过。${error.message}`)
          return
        }

        this.showLoading('start-form')
        const pictures = await upload(form.pictures)
        form.pictures = JSON.stringify(pictures)
        console.log({ form })
        try {
          await startProcess.call(this, form)
          this.$message.success('流程发起成功')
          this.emitClose()
        } catch (error) {
          this.$message.error(error.message)
        } finally {
          this.hideLoading('start-form')
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/page/none/workflow/not-house-input/start-dialog.vue